import React, { useEffect } from 'react';
import AnimatedAlert from './components/ui/AnimatedAlert';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';
import ContactUsPage from './components/pages/ContactUsPage';
import HomePage from './components/pages/HomePage';
import MainMenu from './components/ui/menu/MainMenu';
import AboutPage from './components/pages/AboutPage';
import NotFound from './components/pages/NotFound';
import SearchPage from './components/pages/SearchPage';
import BusinessProfilePage from './components/pages/BusinessProfilePage';
import ProfilePage from './components/pages/ProfilePage';
import MemberHomePage from './components/pages/MemberHomePage';
import LegalPage from './components/pages/LegalPage';
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme, createStyles, makeStyles } from '@material-ui/core/styles';
import { loadCSS } from 'fg-loadcss';
import Logo from './components/ui/Logo';
import './static/css/App.css';
import { Grid, Theme, CssBaseline } from '@material-ui/core';
import { getGroups, hasIdToken } from 'components/auth';

const defaultTheme = createMuiTheme();
const { breakpoints } = defaultTheme;

const theme = createMuiTheme({
  overrides: {
    MuiTypography: {
      h1: {
        fontSize: "4rem",
        [breakpoints.down("xs")]: {
          fontSize: "3rem"
        }
      },
      h2: {
        fontSize: "2rem",
        [breakpoints.down("xs")]: {
          fontSize: "1rem"
        }
      }
    }
  },  
  palette: {
    primary: { 
      main: '#282828',
      dark: '#282828' 
    },
    secondary: {
      main: '#0077B7'
    }
  },
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      // minWidth:1200
    },
    
    paper: {
      padding: theme.spacing(0),
      textAlign: 'left',
      color: theme.palette.text.secondary,
    }
  })
);

const App: React.FC = () => {
  const classes = useStyles();
  const hasToken = hasIdToken();
  const [authenticated, setAuthenticated] = React.useState(hasToken);
  const cognitoGroups = getGroups();
  const [groups, setGroups] = React.useState(cognitoGroups);
  const [isLoading, setIsLoading] = React.useState<Boolean>(false);

  useEffect(() => {
    loadCSS(
      'https://use.fontawesome.com/releases/v5.1.0/css/all.css',
      document.querySelector('#font-awesome-css'),
    );


    // const loadingListener = (event: any) => {
    //   console.log('loadingListener', event)
    //   setIsLoading(event.isLoading);
    // }; 
    // bus.once(Events.loadingChange, loadingListener);
    // return () => { bus.off(Events.loadingChange, loadingListener); }
  }, []);

  let location = useLocation();
  let menu, footer;
  switch(location.pathname) {
    case '/member-home':
      break;
    default:
      menu = <MainMenu/>
      footer = undefined;
      break;
  }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className={classes.root}>

        <Grid container spacing={0}>
          <Grid item xs={12}>
              <header className='App-header'> 
                <Logo />{menu}
              </header>
              <AnimatedAlert />    
          </Grid>
          {location.pathname != '/search' && 
            <Grid item xs={2}></Grid>
          }
          <Grid item xs={12}>
            <div className="page">
              <Switch>
                <Route exact path="/" component={HomePage} />
                <Route exact path="/about" component={AboutPage} />
                {/* { groups && ['searcher', 'admin'].filter(f => groups.indexOf(f) > -1).length > 0 && */}
                 <Route exact path="/search" component={SearchPage} />
                   {/* } */}
                <Route exact path="/contact-us" component={ContactUsPage} />
                { authenticated && <Route exact path="/profile" component={ProfilePage} /> }
                <Route exact path="/business-profile" component={BusinessProfilePage} />
                <Route exact path="/member-home" component={MemberHomePage} />
                <Route exact path="/legal" component={LegalPage} />
                <Route path="*" component={NotFound} />
              </Switch>
            </div>
          </Grid>
          {location.pathname != '/search' && 
            <Grid item xs={2}></Grid>
          }          <Grid item xs={12}>
            {footer}
          </Grid>
        </Grid>
      </div>
    </ThemeProvider>
  );
}

export default App;
